/**
 * React Strict Mode runs mount effects twice in development (setup → cleanup → setup).
 * Schedule work for the next macrotask and cancel it on cleanup so discarded mounts
 * do not double-count funnel ingest (or similar one-shot side effects).
 */
export function afterStrictModeMount(callback: () => void): () => void {
  let cancelled = false;
  const id = setTimeout(() => {
    if (!cancelled) callback();
  }, 0);
  return () => {
    cancelled = true;
    clearTimeout(id);
  };
}
